import toast from "react-hot-toast";
import { baseUrl } from "./baseUrl";

type CampaignReport = any; // replace with real type if you have one

export async function fetchAllCampaignsReports() {
  const all: CampaignReport[] = [];
  let page = 1;
  let hasNext = true;

  try {
    while (hasNext) {
      const url = new URL(`${baseUrl}/admin/campaigns/reports`);
      url.searchParams.set("page", String(page));

      const res = await fetch(url.toString(), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("admin_token")}`,
        },
      });

      const payload = (await res.json()) as {
        success: boolean;
        message: string;
        data: {
          reports: CampaignReport[];
        };
      };

      if (!res.ok) {
        const m = payload.message?.toLowerCase();
        if (
          m === "invalid token" ||
          m === "jwt malformed" ||
          m === "jwt expired"
        ) {
          sessionStorage.removeItem("admin_token");
          toast.error("Session expired, please sign in again");
          window.location.href = "/auth/sign-in";
          throw new Error("Unauthorized");
        }
        throw new Error(payload.message || `HTTP ${res.status}`);
      }

      if (!payload.success) {
        throw new Error(payload.message || "Failed to fetch campaigns");
      }

      const reports = payload.data.reports ?? [];

      all.push(...reports);

      // ✅ pagination exit condition
      if (reports.length === 0) {
        hasNext = false;
      } else {
        page += 1;
      }
    }

    return all;
  } catch (err) {
    console.error("Error fetching all campaigns report:", err);
    throw err;
  }
}
